import React, { useState } from "react";
import { MapPin, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from "./LanguageSwitcher";

interface HeaderProps {
  title?: string;
  location?: string;
  onLocationClick?: () => void;
}

const Header = ({
  title = "Salah Tidsspårare",
  location = "Stockholm, Sverige",
  onLocationClick = () => {},
}: HeaderProps) => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Translate the title based on current language
  const translatedTitle = i18n.language === 'en' ? 'Salah Timekeeper' : 'Salah Tidsspårare';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Return null to completely remove the header
  return null;
};

export default Header;
